import React from 'react';
import styled, { keyframes } from 'styled-components';

const gradientAnimation = keyframes`
  0% {
    background-position-x: -200%;
  }
  100% {
    background-position-x: 200%;
  }
`;

const SkeletonElement = styled.div`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  background-position-x: -200%;
  animation: 1.5s ${gradientAnimation} ease-in-out infinite;
  border-radius: 4px;
`;

const BranchSkeletonContainer = styled.div`
  text-align: center;
  background: #f8f9fa;
  padding: 24px;
  border-radius: 12px;
  position: relative;
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.1);
  min-height: 280px;
`;

const ProgressSkeleton = styled(SkeletonElement)`
  position: absolute;
  right: 15px;
  top: 15px;
  width: 60px;
  height: 20px;
  border-radius: 10px;
`;

const IconSkeleton = styled(SkeletonElement)`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 10px;
`;

const TypeLabelSkeleton = styled(SkeletonElement)`
  width: 100px;
  height: 14px;
  margin-bottom: 5px;
  border-radius: 4px;
`;

const TitleSkeleton = styled(SkeletonElement)`
  width: 80%;
  height: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
`;

const ResponsibleSkeleton = styled(SkeletonElement)`
  width: 70%;
  height: 12px;
  margin-bottom: 5px;
  border-radius: 4px;
`;

const ContactSkeleton = styled(SkeletonElement)`
  width: 50%;
  height: 12px;
  border-radius: 4px;
`;

const BranchSkeleton = ({ id }) => {
  return (
    <BranchSkeletonContainer id={`branch-skeleton-${id}`}>
      <ProgressSkeleton id={`branch-skeleton-progress-${id}`} />
      <IconSkeleton id={`branch-skeleton-icon-${id}`} />
      <TypeLabelSkeleton id={`branch-skeleton-type-${id}`} />
      <TitleSkeleton id={`branch-skeleton-title-${id}`} />
      <ResponsibleSkeleton id={`branch-skeleton-responsible-${id}`} />
      <ContactSkeleton id={`branch-skeleton-contact-${id}`} />
    </BranchSkeletonContainer>
  );
};

export default BranchSkeleton;
